<template>
    <div class="unit-types-modal-wrapper" :class="{['is-mobile']: isMobile}">
        <div class="overlay" @click="onCloseCallback" v-if="show"></div>
        <div class="modal unit-types-modal" v-if="show">
            <div class="modal-content">
                <unit-card
                    v-for="(unitType, i) in unitTypes"
                    :key="`unit-card-${unitType}-${i}`"
                    :unit-type="unitType.type"
                    :image-name="unitType.imageName"
                    :quantity="unitType.quantity"
                />
            </div>
			<span class="dismiss-btn" @click="onCloseCallback">
            	<fa-icon class="icon" icon="times" />
			</span>
        </div>
    </div>
</template>

<script>
import { MOBILE_MAX_WIDTH } from '../../App-types';
import { isMobileDevice } from '../../helpers/general';

export default {
    props: [
        'unitTypes',
        'show',
        'onCloseCallback',
    ],
    name: 'UnitTypesModal',
	data() {
		return {
			windowWidth: window.innerWidth,
		}
	},
    computed: {
        isMobile() {
            return this.windowWidth <= MOBILE_MAX_WIDTH || isMobileDevice();
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .modal {

        &.unit-types-modal {
            background: $cream;
            height: 100%;
            max-width: none;
            padding: 40px 20px;
            top: 0;
            transform: translateX(-50%);
            width: auto;

            &.is-mobile {
                height: auto;
                padding: 20px 45px;
                top: 50%;
                transform: translate(-50%, -50%);

                .modal-content {
                    flex-direction: row;

                    .unit-card {
                        align-self: center;
                        margin-bottom: 0;
                        margin-right: 20px;

                        &:last-of-type {
                            margin-right: 0;
                        }
                    }
                }
            }

            .modal-content {
                display: flex;
                flex-direction: column;
                height: 100%;
                max-width: none;
                overflow: auto;

                .unit-card {
                    align-self: center;
                    margin-bottom: 20px;

                    &:last-of-type {
                        margin-bottom: 0;
                    }
                }
            }

            .dismiss-btn {
                cursor: pointer;
                font-size: 1.6em;
                position: absolute;
                right: 15px;
                top: 10px;
            }
        }
    }

    @media only screen and (min-width: $screen-xs) {

        .modal {

            &.unit-types-modal {
                height: auto;
                padding: 20px 45px;
                top: 50%;
                transform: translate(-50%, -50%);

                .modal-content {
                    flex-direction: row;

                    .unit-card {
						align-self: flex-start;
                        margin-bottom: 0;
                        margin-right: 20px;

                        &:last-of-type {
                            margin-right: 0;
                        }
                    }
                }
            }
        }
    }

</style>
